import React from 'react'
import propTypes from 'prop-types'
import styled from 'styled-components'

const Title = styled.div`
  font-size: 4.7em;
  line-height: 1.1em;
  @media (max-width:1410px) {
    font-size: 4.4em;
  }
  @media (max-width:1380px) {
    font-size: 3.8em;
  }
  @media (max-width:1050px) {
    font-size: 3.2em;
  }
  @media (max-width:600px) {
    font-size: 2.2em;
  }
`
const SubTitle = styled.div`
  font-size: 1.5em;
  @media (max-width:1280px) {
    font-size: 1.2em;
  }
  @media (max-width:600px) {
    font-size: .9em;
  }
`
const Content = styled.div`
  padding-right: 0px;
  padding-left: 0px;
  @media (min-width:990px) {
    flex: 0 0 38%;
    max-width: 38%;
  }
  @media (max-width:1625px) and (min-width:990px) {
    flex: 0 0 42%;
    max-width: 42%;
  }
  @media (max-width:1475px) and (min-width:990px) {
    flex: 0 0 44%;
    max-width: 44%;
  }
  @media (max-width:1150px) and (min-width:990px) {
    flex: 0 0 48%;
    max-width: 48%;
  }

`
const Limiter = styled.div`
  width: 85%;
  max-width: 85%;
  @media (max-width:950px) {
    width: 95%;
    max-width: 95%;
  }
`

const Cover = props => {
  return (
    <section className='padding-portada-serv'>
      <div className='servicios-website-cover' style={{ zIndex: 2, backgroundImage: `url(${props.picture || 'https://www.laboratoriosiml.com/images/iml-laboratorio-medeico-servicios.jpg'})` }} />
      <Limiter className='container'>
        <div className='row py-lg-5'>
          <Content className='col-12 col-lg-4 py-5'>
            <Title className='font-weight-bold text-size-sub'>
              {props.title || 'Servicios'}
            </Title>
            {props.text && (
              <SubTitle>
                {props.text}
              </SubTitle>
            )}
          </Content>
        </div>
      </Limiter>
    </section>
  )
}

export default Cover

Cover.propTypes = {
  picture: propTypes.string,
  text: propTypes.string,
  title: propTypes.string
}
